export const formatElapsedTime = (
  elapsedSeconds: number
): string => {
  const hours = Math.floor(elapsedSeconds / 3600);
  const minutes = Math.floor((elapsedSeconds % 3600) / 60);
  const seconds = elapsedSeconds % 60;

  return [hours, minutes, seconds]
    .map((value) => value.toString().padStart(2, '0'))
    .join(':');
};

type ActiveElapsedTimeInput = {
  startedAt: string;
  pausedAt?: string | null;
  pausedDurationSeconds?: unknown;
  currentTime: number;
};

export const calculateActiveElapsedSeconds = ({
  startedAt,
  pausedAt,
  pausedDurationSeconds,
  currentTime
}: ActiveElapsedTimeInput): number => {
  const startedAtTime = new Date(startedAt).getTime();
  const elapsedUntil = pausedAt
    ? new Date(pausedAt).getTime()
    : currentTime;
  const parsedPausedDuration = Number(pausedDurationSeconds ?? 0);
  const completedPausedDuration =
    Number.isFinite(parsedPausedDuration) &&
    parsedPausedDuration >= 0
      ? parsedPausedDuration
      : 0;

  if (
    !Number.isFinite(startedAtTime) ||
    !Number.isFinite(elapsedUntil)
  ) {
    return 0;
  }

  return Math.max(
    0,
    Math.floor(
      (elapsedUntil - startedAtTime) / 1000 -
        completedPausedDuration
    )
  );
};
